export type TextCase =
  | "upper"
  | "lower"
  | "title"
  | "sentence"
  | "camel"
  | "pascal"
  | "snake"
  | "kebab"
  | "constant"
  | "alternating"
  | "inverse";

export const textCases: TextCase[] = [
  "upper",
  "lower",
  "title",
  "sentence",
  "camel",
  "pascal",
  "snake",
  "kebab",
  "constant",
  "alternating",
  "inverse",
];

const capitalize = (word: string) =>
  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();

// Split text into words, also breaking on camelCase / PascalCase boundaries.
const splitWords = (text: string): string[] =>
  text
    .replace(/([\p{Ll}\p{N}])(\p{Lu})/gu, "$1 $2")
    .replace(/(\p{Lu})(\p{Lu}\p{Ll})/gu, "$1 $2")
    .match(/[\p{L}\p{N}]+/gu) ?? [];

export function convertCase(text: string, textCase: TextCase): string {
  switch (textCase) {
    case "upper":
      return text.toUpperCase();
    case "lower":
      return text.toLowerCase();
    case "title":
      return text
        .toLowerCase()
        .replace(/\p{L}[\p{L}'’]*/gu, (word) => capitalize(word));
    case "sentence":
      return text
        .toLowerCase()
        .replace(/(^\s*|[.!?]\s+|\n\s*)(\p{L})/gu, (_, lead: string, letter: string) =>
          lead + letter.toUpperCase(),
        );
    case "camel": {
      const words = splitWords(text);
      return words
        .map((word, i) => (i === 0 ? word.toLowerCase() : capitalize(word)))
        .join("");
    }
    case "pascal":
      return splitWords(text).map(capitalize).join("");
    case "snake":
      return splitWords(text)
        .map((w) => w.toLowerCase())
        .join("_");
    case "kebab":
      return splitWords(text)
        .map((w) => w.toLowerCase())
        .join("-");
    case "constant":
      return splitWords(text)
        .map((w) => w.toUpperCase())
        .join("_");
    case "alternating": {
      let letterIndex = 0;
      return Array.from(text)
        .map((char) => {
          if (char.toLowerCase() === char.toUpperCase()) return char;
          const result =
            letterIndex % 2 === 0 ? char.toLowerCase() : char.toUpperCase();
          letterIndex++;
          return result;
        })
        .join("");
    }
    case "inverse":
      return Array.from(text)
        .map((char) =>
          char === char.toUpperCase() ? char.toLowerCase() : char.toUpperCase(),
        )
        .join("");
  }
}
